module.exports = __webpack_public_path__ + "static/media/11_MBTA - Boston.f280d500.jpg";